import { PERMISSION_RESOURCE } from '../../shared/permissions/permissions.types';
import { ApiPermission } from '../api-types/permission.api';
import { Permission } from '../app-types/permission.app';

const PERMISSION_NAME_ALIASES: Record<string, PERMISSION_RESOURCE> = {
	// Backend currently returns PositionShares scope without "Users." prefix and without ".Own" separator.
	'PositionShares.Read': 'Users.PositionShares.Read',
	'PositionShares.Edit': 'Users.PositionShares.Edit',
	'PositionShares.ReadOwn': 'Users.PositionShares.Read.Own',
	'Users.PositionShares.ReadOwn': 'Users.PositionShares.Read.Own',
	// Backend currently returns substitutes own read without ".Own" separator.
	'Users.Substitutes.ReadOwn': 'Users.Substitutes.Read.Own',
	'Users.EditOwn.Restricted': 'Users.Edit.Own.Restricted',
};

function normalizePermissionName(name: string): PERMISSION_RESOURCE {
	const normalized = PERMISSION_NAME_ALIASES[name];
	return (normalized ?? name) as PERMISSION_RESOURCE;
}

/**
 * converts the entity coming from API into the model we use internally inside the app
 */
export function transformApiPermissionToAppPermission(input: ApiPermission): Permission {
	const output: Permission = {
		action: input.action,
		id: input.id,
		name: normalizePermissionName(input.name),
		resource: input.resource,
		description: input.description,
	};

	return output;
}

/**
 * converts multiple entities from array to a new array which we can use internally for permissions
 */
export function transformApiPermissionsToAppPermissions(inputs: ApiPermission[]): Permission[] {
	return inputs.map((input) => transformApiPermissionToAppPermission(input));
}
